var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.95064 15.3775C13.0911 15.3775 16.996 9.46182 16.996 4.33216C16.996 4.16415 16.9925 3.99683 16.985 3.83043C17.7429 3.28242 18.4017 2.59856 18.9214 1.82016C18.2259 2.12946 17.4772 2.33739 16.6921 2.43147C17.4935 1.95068 18.1089 1.19045 18.3991 0.28419C17.6491 0.728874 16.8184 1.05194 15.9341 1.22644C15.2257 0.471876 14.217 0 13.1003 0C10.9566 0 9.21801 1.73847 9.21801 3.88146C9.21801 4.18625 9.25215 4.48247 9.31868 4.76666C6.09227 4.60432 3.23116 3.05967 1.31669 0.710707C0.983441 1.28429 0.791127 1.9508 0.791127 2.66197C0.791127 4.00863 1.47649 5.19781 2.5186 5.89324C1.88172 5.87369 1.28348 5.69884 0.760463 5.40783C0.759885 5.42414 0.759885 5.44 0.759885 5.45735C0.759885 7.33745 2.09799 8.90721 3.87452 9.26291C3.54821 9.35166 3.20489 9.39945 2.85081 9.39945C2.6011 9.39945 2.35764 9.37492 2.12113 9.32944C2.61534 10.8719 4.04855 11.9943 5.74768 12.0258C4.41895 13.0672 2.74517 13.6875 0.926048 13.6875C0.613161 13.6875 0.303861 13.6696 0 13.6337C1.7181 14.735 3.75823 15.3776 5.95075 15.3776",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.92d86319f3095b63868b43b58b7be8a3.svg";
export { ForwardRef as ReactComponent };